var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 12 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 0H0.666667C0.298477 0 0 0.298477 0 0.666667V4.58333C0 4.95152 0.298477 5.25 0.666667 5.25H4.58333C4.95152 5.25 5.25 4.95152 5.25 4.58333V0.666667C5.25 0.298477 4.95152 0 4.58333 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.5V3.75C10.6667 3.84208 10.5921 3.91667 10.5 3.91667H8.25C8.15792 3.91667 8.08333 3.84208 8.08333 3.75V1.5C8.08333 1.40792 8.15792 1.33333 8.25 1.33333H10.5C10.5921 1.33333 10.6667 1.40792 10.6667 1.5ZM11.3333 0H7.41667C7.04833 0 6.75 0.298333 6.75 0.666667V4.58333C6.75 4.95167 7.04833 5.25 7.41667 5.25H11.3333C11.7017 5.25 12 4.95167 12 4.58333V0.666667C12 0.298333 11.7017 0 11.3333 0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.75H7.41667C7.04848 6.75 6.75 7.04848 6.75 7.41667V11.3333C6.75 11.7015 7.04848 12 7.41667 12H11.3333C11.7015 12 12 11.7015 12 11.3333V7.41667C12 7.04848 11.7015 6.75 11.3333 6.75Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91667 8.25V10.5C3.91667 10.5921 3.84208 10.6667 3.75 10.6667H1.5C1.40792 10.6667 1.33333 10.5921 1.33333 10.5V8.25C1.33333 8.15792 1.40792 8.08333 1.5 8.08333H3.75C3.84208 8.08333 3.91667 8.15792 3.91667 8.25ZM4.58333 6.75H0.666667C0.298333 6.75 0 7.04833 0 7.41667V11.3333C0 11.7017 0.298333 12 0.666667 12H4.58333C4.95167 12 5.25 11.7017 5.25 11.3333V7.41667C5.25 7.04833 4.95167 6.75 4.58333 6.75Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardViewIcon);
export default __webpack_public_path__ + "static/media/CardViewIcon.f70bfff4f70cfd031cfb28d5d2c022af.svg";
export { ForwardRef as ReactComponent };